import { OperationTime, OperationTimeQC, Tags } from '../../../constants/Enum'
import { getMinuteTimeV2 } from '../../../utilities/Format'
import { getRemainTime } from '../../Tables/OperationLogTable'
import { isJson } from '../../../utilities/Validate'

export const buildConfirmation = (orderId, opNo, logs) => {
  let confirmationsNoDown = []
  // setup, run time logs
  logs.filter(log => !log.downtimeCode).filter(log => log.timeType !== OperationTime.SOAP_BASE).forEach(log => {
    const existId = confirmationsNoDown.findIndex(c => c.postingDate === log.postingDate
      && c.noOfEmployee === (log.totalEmployeeRT ? log.totalEmployeeRT : 0) + (log.totalEmployeeOT ? log.totalEmployeeOT : 0)
      && (c.employeeRT === log.totalEmployeeRT || c.employeeOT === log.totalEmployeeOT))

    if (existId >= 0) {
      // found - accumulate
      const accumulated = {...confirmationsNoDown[existId]}
      accumulated.yield += (log.yield ? log.yield : 0)
      accumulated.scrap += (log.scrap ? log.scrap : 0)
      accumulated.bulkUsedQty += (log.bulkUsedQty ? log.bulkUsedQty : 0)
      accumulated.setupTime += (log.timeType === OperationTime.SETUP_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0)
      accumulated.runTime += (log.timeType === OperationTime.RUN_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0)
      accumulated.downTime += (log.timeType === OperationTime.DOWN_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0)

      const totalMinutes = accumulated.setupTime + accumulated.runTime + accumulated.downTime
      accumulated.laborTime = accumulated.employeeRT * totalMinutes
      accumulated.overTime = accumulated.employeeOT * totalMinutes

      if (log.finishedTime && log.finishedTime > accumulated.finishedTime) accumulated.finishedTime = log.finishedTime

      confirmationsNoDown[existId] = accumulated
    } else {
      // not found - push to array
      confirmationsNoDown.push({
        batchNo: log.batchNo || '',
        postingDate: log.postingDate,
        productionOrderId: orderId,
        operationNo: opNo,
        noOfEmployee: (log.totalEmployeeRT ? log.totalEmployeeRT : 0) + (log.totalEmployeeOT ? log.totalEmployeeOT : 0),
        employeeRT: log.totalEmployeeRT ? log.totalEmployeeRT : 0,
        employeeOT: log.totalEmployeeOT ? log.totalEmployeeOT : 0,

        yield: log.yield ? log.yield : 0,
        scrap: log.scrap ? log.scrap : 0,
        bulkUsedQty: log.bulkUsedQty ? log.bulkUsedQty : 0,
        setupTime: log.timeType === OperationTime.SETUP_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0,
        runTime: log.timeType === OperationTime.RUN_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0,
        downTime: log.timeType === OperationTime.DOWN_TIME ? getMinuteTimeV2(log.startedTime, log.finishedTime) : 0,
        // downTimeCode: log.downtimeCode ? log.downtimeCode : '',
        downTimeCode: '',
        laborTime: (log.totalEmployeeRT ? log.totalEmployeeRT : 0) * getMinuteTimeV2(log.startedTime, log.finishedTime),
        overTime: (log.totalEmployeeOT ? log.totalEmployeeOT : 0) * getMinuteTimeV2(log.startedTime, log.finishedTime),
        finishedTime: log.finishedTime ? log.finishedTime : 0,
        split: log.split ? log.split : 1
      })
    }
  })

  // downtime logs
  let confirmationsDown = []
  logs.filter(log => log.downtimeCode && log.timeType !== OperationTimeQC.INSPECT_BULK).forEach(log => {
    const existId = confirmationsDown.findIndex(c => c.postingDate === log.postingDate
      && c.noOfEmployee === (log.totalEmployeeRT ? log.totalEmployeeRT : 0) + (log.totalEmployeeOT ? log.totalEmployeeOT : 0)
      && (c.employeeRT === log.totalEmployeeRT || c.employeeOT === log.totalEmployeeOT)
      && c.downTimeCode === log.downtimeCode)
    if (existId >= 0) {
      const accumulated = {...confirmationsDown[existId]}
      const minutes = getRemainDownTime(log)
      accumulated.yield += (log.yield ? log.yield : 0)
      accumulated.scrap += (log.scrap ? log.scrap : 0)
      accumulated.bulkUsedQty += (log.bulkUsedQty ? log.bulkUsedQty : 0)
      accumulated.setupTime += (log.timeType === OperationTime.SETUP_TIME ? minutes : 0)
      accumulated.runTime += (log.timeType === OperationTime.RUN_TIME ? minutes : 0)
      accumulated.downTime += (log.timeType === OperationTime.DOWN_TIME ? minutes : 0)
      accumulated.employeeRT = log.totalEmployeeRT ? log.totalEmployeeRT : 0
      accumulated.employeeOT = log.totalEmployeeOT ? log.totalEmployeeOT : 0

      const totalMinutes = accumulated.setupTime + accumulated.runTime + accumulated.downTime
      accumulated.laborTime = accumulated.employeeRT * totalMinutes
      accumulated.overTime = accumulated.employeeOT * totalMinutes

      if (log.finishedTime && log.finishedTime > accumulated.finishedTime) accumulated.finishedTime = log.finishedTime

      confirmationsDown[existId] = accumulated
    } else {
      const minutes = getRemainDownTime(log)
      confirmationsDown.push({
        batchNo: log.batchNo || '',
        postingDate: log.postingDate,
        productionOrderId: orderId,
        operationNo: opNo,
        noOfEmployee: (log.totalEmployeeRT ? log.totalEmployeeRT : 0) + (log.totalEmployeeOT ? log.totalEmployeeOT : 0),
        employeeRT: log.totalEmployeeRT ? log.totalEmployeeRT : 0,
        employeeOT: log.totalEmployeeOT ? log.totalEmployeeOT : 0,

        yield: log.yield ? log.yield : 0,
        scrap: log.scrap ? log.scrap : 0,
        bulkUsedQty: log.bulkUsedQty ? log.bulkUsedQty : 0,
        setupTime: log.timeType === OperationTime.SETUP_TIME ? minutes : 0,
        runTime: log.timeType === OperationTime.RUN_TIME ? minutes : 0,
        downTime: log.timeType === OperationTime.DOWN_TIME ? minutes : 0,
        downTimeCode: log.downtimeCode ? log.downtimeCode : '',
        laborTime: (log.totalEmployeeRT ? log.totalEmployeeRT : 0) * minutes,
        overTime: (log.totalEmployeeOT ? log.totalEmployeeOT : 0) * minutes,
        finishedTime: log.finishedTime ? log.finishedTime : 0,
        split: log.split ? log.split : 1
      })
    }
  })
  const allConfirmattions = [...confirmationsNoDown, ...confirmationsDown.filter(dt => dt.downTime > 0)].sort((a, b) => b.yield - a.yield)
  return { confirmations: allConfirmattions, goodMovements: buildGoodMoveMents(logs) }
}

export const buildGoodMoveMents = (logs) => {
	const groupedByBatchNo = logs.reduce(function (rv, x) {
		const batchNo = x['batchNo'] || '';
    (rv[batchNo] = rv[batchNo] || []).push(x.bulkUsedQty);
    return rv;
	}, {})
	// {
	// 	"0807210150": [ 0, 120 ]
	// }
	return Object.keys(groupedByBatchNo).map(batch => {
		const bulkUsedQty = groupedByBatchNo[batch].reduce((prev, cur) => prev + (cur ? cur : 0), 0)
		return {
			BATCH: batch,
			QTY: `${bulkUsedQty > 0 ? bulkUsedQty : "0.000"}`,
		}
	})
	// [ { BATCH: "0807210150", QTY: "120" } ]
}
const getRemainDownTime = (log) => {
  let remainTime = getMinuteTimeV2(log.startedTime, log.finishedTime) - (log.downtimeBaseTime ? log.downtimeBaseTime : 0)

  return remainTime < 0 ? 0 : remainTime
}


export const mergeUpdateToOriginWorkCenters = (originWcs, updatedWorkCenter) => {
  if (!updatedWorkCenter) return originWcs

  const tempWcs = [...originWcs]
  Object.keys(updatedWorkCenter).forEach(key => {
    const idx = tempWcs.findIndex(wc => wc.operationNo === key)
    if (idx < 0) {
      tempWcs.push(updatedWorkCenter[key])
    } else {
      tempWcs[idx] = { ...tempWcs[idx], ...updatedWorkCenter[key] }
    }
  })
  return tempWcs
}

export const compareLatestOpearationWithOrigin = (operationNo, actualWorkCenterId, latestOp) => {
  // Check exist operation
  if (!latestOp) {
    return { allow : false, message: `ไม่พบข้อมูล Op. ${operationNo} หรือ WC ไม่ตรงกับ -C บน SAP` }
  }
  // Check is edit wc
  const latestWcFromSAP = latestOp['WC_NO']

  return { allow : true, message:
    (!actualWorkCenterId || actualWorkCenterId === latestWcFromSAP) ? '' : `ข้อมูล Operation ${operationNo} \n จาก SAP ไม่ตรงกับในระบบ` }
}

export const countEditWc = (workCenters) => {
  return workCenters.reduce((prev, cur) => prev +
    (cur.actualWorkCenterId && cur.actualWorkCenterId !== cur.workCenterId), 0)
}

export const groupByMachine = (logs) => {
  return [...new Set(logs.filter(log => log.timeType !== OperationTimeQC.INSPECT_BULK).map(log => isNaN(log.mch) || !log.mch ? log.mch : log.mch.padStart(2, '0')))]
  // If log.mch is number add lpad, else nothing
}

export const checkWCC = ({ listsOpFromSAP, currentOperationNo, currentWorkCenterId }) => {
  if(listsOpFromSAP && listsOpFromSAP.length > 0 && currentOperationNo && currentWorkCenterId){
    // check listsOpFromSAP => ACTIVITY_NUM matching with currentOperationNo-1
    const opCosting = listsOpFromSAP.find(listOpFromSAP => Number(listOpFromSAP['ACTIVITY_NUM']) === Number(currentOperationNo)-1)
    // check opCosting not find or WC_NO of -C matching with [currentWorkCenterId]-C return true
    const opWCC = !opCosting || (opCosting && opCosting['WC_NO'].toUpperCase() === `${currentWorkCenterId}-C`.toUpperCase()) ? true : false
    // check WC-C if find return true or not find retrun false
    return { statusWCC: opWCC, actualOpCosting: opCosting }
  }
  // case not find ACTIVITY_NUM retrun true
  return { statusWCC: true }
}

export const validateRtOtLogs = (logs, isCheckLot = true) => {
  const invalidCount = logs.reduce((prev, current) => {
    let invalid = false
    const isManHourEmpty = (current.totalEmployeeRT || 0) === 0 && (current.totalEmployeeOT || 0) === 0
    const isInvalidTime = (current.finishedTime || 0) === 0
    const isInvalidBatchNo = current.batchNo ? /\s/.test(current.batchNo) : false
    if (current.downtimeCode) {
      // downtime log - check if actual time > 0
      const actualTime = getRemainTime(current)
      invalid = actualTime > 0 ? isManHourEmpty : false
    } else {
      // other log - check all
      invalid = isManHourEmpty || isInvalidTime || (isInvalidBatchNo && isCheckLot)
    }
    return prev + (invalid ? 1 : 0)
  }, 0)
  return invalidCount === 0
}

export const handleOrderTags = (order, tags) => {
  let dataReturn = {'status': false, 'isDuplicateTag': false, 'tags': []}
  if(!order) return dataReturn
  if(!tags) return dataReturn
  const checkTags = order.tags && isJson(order.tags) && Array.isArray(JSON.parse(order.tags))
  const isDuplicateTag = checkTags && JSON.parse(order.tags).find(tag => tag.toUpperCase() === Tags.PARTIAL.toUpperCase())
  // check Duplicate
  if(isDuplicateTag){
    dataReturn.status = true
    dataReturn.isDuplicateTag = true
    return dataReturn
  }
  let tempTags = []
  if(checkTags) tempTags = JSON.parse(order.tags)
  if(!isDuplicateTag) tempTags.push(tags)
  dataReturn.status = true
  dataReturn.tags = tempTags
  return dataReturn
}

export const handleRemoveOrderTags = (order, tags) => {
  let tempTags = []
  if(!order) return tempTags
  if(!tags) return tempTags
  const checkTags = order.tags && isJson(order.tags) && Array.isArray(JSON.parse(order.tags))
  const foundTag = checkTags && JSON.parse(order.tags).find(tag => tag.toUpperCase() === Tags.PARTIAL.toUpperCase())
  if(checkTags) tempTags = JSON.parse(order.tags)
  if(checkTags && foundTag) tempTags = removeFrmArr(tempTags, tags)
  return tempTags
}

const removeFrmArr = (array, element) => {
  return array.filter(e => e !== element);
};

